import { useRef } from 'react';

const galleryImages = [
  {
    id: 1,
    url: 'https://readdy.ai/api/search-image?query=close-up%20shot%20of%20Pakistani%20bun%20kebab%20with%20green%20chutney%20dripping%20down%2C%20golden%20fried%20patty%2C%20fresh%20onions%2C%20held%20in%20hands%2C%20simple%20clean%20background%2C%20professional%20food%20photography%20with%20shallow%20depth%20of%20field&width=400&height=400&seq=gallery1&orientation=squarish',
    title: 'Signature Bun Kebab'
  },
  {
    id: 2,
    url: 'https://readdy.ai/api/search-image?query=steaming%20hot%20chicken%20roll%20being%20unwrapped%2C%20tender%20chicken%20pieces%20visible%20with%20fresh%20vegetables%2C%20simple%20clean%20background%2C%20professional%20food%20photography%20with%20steam%20effect&width=400&height=400&seq=gallery2&orientation=squarish',
    title: 'Fresh Chicken Roll'
  },
  {
    id: 3,
    url: 'https://readdy.ai/api/search-image?query=colorful%20array%20of%20Pakistani%20drinks%20including%20lassi%2C%20fresh%20juices%20and%20cold%20coffee%20in%20traditional%20glasses%20on%20colorful%20Pakistani%20textile%20pattern%20background%2C%20professional%20beverage%20photography&width=400&height=400&seq=gallery3&orientation=squarish',
    title: 'Refreshing Drinks'
  },
  {
    id: 4,
    url: 'https://readdy.ai/api/search-image?query=plate%20of%20golden%20crispy%20samosas%20with%20green%20chutney%2C%20steam%20rising%2C%20on%20rustic%20wooden%20table%2C%20professional%20food%20photography%20with%20warm%20lighting&width=400&height=400&seq=gallery4&orientation=squarish',
    title: 'Crispy Samosas'
  },
  {
    id: 5,
    url: 'https://readdy.ai/api/search-image?query=delicious%20zinger%20burger%20with%20layers%20visible%2C%20cheese%20melting%2C%20on%20colorful%20Pakistani%20textile%20background%2C%20professional%20food%20photography%20with%20vibrant%20colors&width=400&height=400&seq=gallery5&orientation=squarish',
    title: 'Zinger Burger'
  },
  {
    id: 6,
    url: 'https://readdy.ai/api/search-image?query=assortment%20of%20Pakistani%20sweets%20including%20brownies%2C%20cupcakes%20and%20gulab%20jamun%20arranged%20beautifully%20on%20rustic%20wooden%20surface%2C%20professional%20dessert%20photography&width=400&height=400&seq=gallery6&orientation=squarish',
    title: 'Sweet Treats'
  },
  {
    id: 7,
    url: 'https://readdy.ai/api/search-image?query=loaded%20fries%20with%20melted%20cheese%20and%20toppings%2C%20hands%20reaching%20for%20fries%2C%20simple%20clean%20background%2C%20professional%20food%20photography%20with%20cheese%20pull&width=400&height=400&seq=gallery7&orientation=squarish',
    title: 'Loaded Fries'
  },
  {
    id: 8,
    url: 'https://readdy.ai/api/search-image?query=tall%20glass%20of%20creamy%20mango%20lassi%20with%20foam%20on%20top%2C%20mango%20slice%20garnish%2C%20on%20colorful%20Pakistani%20textile%20background%2C%20professional%20beverage%20photography&width=400&height=400&seq=gallery8&orientation=squarish',
    title: 'Mango Lassi'
  },
];

export default function Gallery() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const scrollAmount = 420;
      const newScrollLeft = direction === 'left' 
        ? scrollContainerRef.current.scrollLeft - scrollAmount
        : scrollContainerRef.current.scrollLeft + scrollAmount;
      
      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="gallery" className="py-20 bg-gradient-to-b from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-6xl font-bold text-amber-900 mb-3">Food Gallery</h2>
          <p className="text-2xl text-orange-500 italic" style={{ fontFamily: 'serif' }}>Feast Your Eyes</p>
        </div>

        {/* Gallery Container */}
        <div className="relative">
          {/* Left Arrow */}
          <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-14 h-14 bg-white rounded-full shadow-xl flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all group"
            aria-label="Scroll left"
          >
            <i className="ri-arrow-left-s-line text-3xl text-orange-500 group-hover:text-white"></i>
          </button>

          {/* Right Arrow */}
          <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-14 h-14 bg-white rounded-full shadow-xl flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all group"
            aria-label="Scroll right"
          >
            <i className="ri-arrow-right-s-line text-3xl text-orange-500 group-hover:text-white"></i>
          </button>

          {/* Scrollable Gallery */}
          <div 
            ref={scrollContainerRef}
            className="flex overflow-x-auto gap-5 pb-6 snap-x snap-mandatory scrollbar-hide px-12"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {galleryImages.map((image, index) => (
              <div 
                key={image.id}
                className="flex-shrink-0 snap-start group"
                style={{ width: '400px' }}
              >
                <div className="relative w-full h-[400px] rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                  <img 
                    src={image.url}
                    alt={image.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                    <p className="text-white text-xl font-semibold p-6">{image.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center gap-2 mt-6">
            {galleryImages.map((_, index) => (
              <div 
                key={index}
                className={`w-2 h-2 rounded-full ${index === 0 ? 'bg-orange-500 w-8' : 'bg-gray-300'} transition-all`}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
